import token, { tokenToVars } from '../token';
import Divider from './divider';

export { Divider };
export default tokenToVars(Divider, token);
